import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {fadeInAnimation} from '../../animations/fade-in.animation';
import {PlanDTO} from '../../dtos/billing';

@Component({
  selector: 'app-modal-update-plan',
  templateUrl: './modal-update-plan.component.html',
  styleUrls: ['./modal-update-plan.component.scss'],
  animations: [fadeInAnimation]
})
export class ModalUpdatePlanComponent implements OnInit {

  @Input() isVisibleModal: boolean;
  @Input() currentPlan: PlanDTO;
  @Input() newPlan: PlanDTO;
  @Input() isSubscribe: boolean;
  @Output() closed: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor() { }

  ngOnInit(): void {
  }

  onEmitClose(value: boolean): void {
    this.closed.emit(value);
  }
}
